import { ApiClientProvider } from '@skylabs-digital/react-proto-kit';
import type React from 'react';
import { getBoBaseUrl } from '../config/auth.config';

/**
 * El cliente HTTP del backoffice. No inyecta ningún `Authorization`: en el
 * modelo BFF el navegador no tiene tokens, la credencial es la cookie
 * `HttpOnly` que puso `/api/bo/auth/login`, y `fetch` la manda same-origin
 * por defecto. Las rutas del backoffice viven bajo `/bo`, en el mismo
 * pipeline de auth-hono que la sesión, así que no hace falta ningún puente.
 */
export function AuthenticatedApiProvider({ children }: { children: React.ReactNode }) {
  return (
    <ApiClientProvider connectorType="fetch" config={{ baseUrl: getBoBaseUrl() }}>
      {children}
    </ApiClientProvider>
  );
}
